import { GameWithDate } from '../types/types';

export const demoData: GameWithDate = {
  date: '2000-01-02',
  game: {
    words: [
      { text: 'one', offset: 0 },
      { text: 'two', offset: 0 },
      { text: 'three', offset: 0 },
      { text: 'four', offset: 1 },
    ],
    pathString: 'oneowtthforeeru',
    startCoordinates: { x: 0, y: 0 },
    theme: 'Fun with Numbers',
  },
  _id: 'demo',
};
